"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createMultiCurrencyCurrencyCodeReferenceResolver = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createSimpleCachedReferenceResolver = _interopRequireDefault(require("../lib/createSimpleCachedReferenceResolver"));

var _CacheKeys = _interopRequireDefault(require("../constants/CacheKeys"));

var _MultiCurrencyApi = require("../api/MultiCurrencyApi");

var createMultiCurrencyCurrencyCodeReferenceResolver = function createMultiCurrencyCurrencyCodeReferenceResolver(options) {
  return (0, _createSimpleCachedReferenceResolver.default)((0, _extends2.default)({
    cacheKey: _CacheKeys.default.MULTI_CURRENCY_CURRENCY_CODES,
    createFetchData: _MultiCurrencyApi.createFetchAllCurrencies,
    fetchData: _MultiCurrencyApi.fetchAllCurrencies
  }, options));
};

exports.createMultiCurrencyCurrencyCodeReferenceResolver = createMultiCurrencyCurrencyCodeReferenceResolver;

var _default = createMultiCurrencyCurrencyCodeReferenceResolver();

exports.default = _default;